import script from "./rate-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./rate-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./rate-setting-ly.vue?vue&type=style&index=0&id=fc9b6774&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc9b6774"]])

export default __exports__